import { useStoredBoolean } from 'shared/hooks/use-stored-boolean';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';

const COLLAPSED_KEY_PREFIX = 'griply.upcoming-view-options-collapsed.';

// Stores collapsed rather than open so a section a user has never touched defaults to expanded.
export const useViewOptionsSectionCollapsed = (
  sectionId: ID,
): [boolean, (value: boolean) => void] => {
  const user = useUser();

  return useStoredBoolean(
    `${COLLAPSED_KEY_PREFIX}${user?.uid ?? ''}.${sectionId}`,
  );
};
